export default "__VITE_ASSET__BLtbyo_q__"